import graphqlClient from '../../api/axios_interceptor';
import { getMessagesQuery, askSupportMutation } from "../../api/graphql/queries/messages";
import { FETCH_MESSAGES, ASK_SUPPORT } from '../actions/actionTypes';
import { updateActionErrors } from './updateErrors';
import {convertDateToUserLocalDate} from "../../utils/general"



export const parseMessage = (message) => {
    let propertyId = "";
    let unitId = "";
    let propertyName = "";
    let unitName = "";
    let sendAttempts = "";
    let team = {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: ""
    }
    let tenant = {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: ""
    }

    if (message.tenant){
        if(message.tenant.unit){
            propertyId = message.tenant.unit.property.id;
            propertyName = message.tenant.unit.property.name;
            unitId = message.tenant.unit.id;
            unitName = message.tenant.unit.unitName;
        }

        if (message.tenant.user){
            let user = message.tenant.user;
            tenant = {
                firstName: user.firstName,
                lastName: user.lastName,
                phoneNumber: user.phoneNumber,
                email: user.email
            };
        }
    }

    if (message.team && message.team.user){
        let user = message.team.user;
        team = {
            firstName: user.firstName,
            lastName: user.lastName,
            phoneNumber: user.phoneNumber,
            email: user.email
        }
    }
    return ({
        messageId: message.id,
        propertyId,
        unitId,
        propertyName,
        unitName,
        team,
        tenant,
        sendAttempts: message.sendAttempts.length,
        createdTs: convertDateToUserLocalDate(message.createdTs),
        message: message.message,
        messageType: message.messageType || '',
        delivered: message.delivered,
        failReason: message.failReason,
        shortenedMessage: message.message.length > 20? message.message.substring(0, 20) + " ..." : message.message
    });
}

export const fetchMessageMiddleware = async (action) => {
    try{
        let messages = {};
        const query = getMessagesQuery(action.payload);
        await graphqlClient({
            data: {
                query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else {
                messages =  queryResult.data.data.messages.messages.map(parseMessage);
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        messages
                    },
                    offset: queryResult.data.data.messages.next,
                    summary: queryResult.data.data.messages.summary
                });
            }
        });
    }catch(error){
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

export const askSupportMiddleware = async (action) => {
    try{
        const query = askSupportMutation(action.payload);
        await graphqlClient({
            data: {query},
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            }
        })
    }catch(error){
        console.error(error);
        action = updateActionErrors(action, error);
    }
    return action;
}
export const messagesMiddleware = storeAPI => next => async action => {
    switch(action.type){
        case FETCH_MESSAGES:
            action = await fetchMessageMiddleware(action);
            break;
        case ASK_SUPPORT:
            action = await askSupportMiddleware(action);
            break;
    }
    return next(action);
}
